import styled from "styled-components";

export const ListContainer = styled.div`
  display: flex;
`;
export const ListItemHead = styled.div`
  font-weight: bold;
  font-size: 18px;
  display: flex;
  margin: 0;
  color: #001E5E;
  padding: 0.5em 1em;
  margin-bottom: 0.5em;
  border-bottom: 1px solid white;
  text-transform: uppercase;
  &:first-child {
    margin-top: 0;
  }
`;
export const ListItem = styled.div`
  display: flex;
  // width: 100%;
  justify-content: space-between;
  gap: 10px;
  padding: 0.5em 1em;
  font-size: 18px;
  svg {
    margin-top: 3px;
    margin-right: 10px;
  }
`;
export const ListItemBold = styled.div`
  display: flex;
  gap: 10px;
  font-weight: 700;
  font-size: 18px;
  color: #001E5E;
  padding: 0.5em 1em;
  svg {
    margin-right: 10px;
  }
`;

export const ListItemQuarter = styled.div`
  display: flex;
  flex: 1 1 25%;
  &.head{
    font-size: 18px;
    font-weight: 700;
    color: #001E5E;
  }
  span {
    margin-left: 10px;
    cursor: pointer;
  }
  &.paid
  {
    color:green;
  }
  &.canceled
  {
    color:red;
  }
  &.open
  {
    color:green;
  }
  @media screen and (max-width: 768px) {
  flex: 0.5 1 auto;
    &.hm {
      display: none;
    }
  }
`;
export const ToolTipContainer = styled.span`
  position: relative;
  display:flex;
  align-items:center;
`;

export const ToolTip = styled.div`
  position: absolute;
  top: 0;
  left: 19px;
  background-color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  margin-bottom: 10px;
  cursor: initial;
  &.language {
    top: 27px;
    left: -40px;
    font-size: 18px;
    @media screen and (max-width: 768px) {
      font-size: 15px;
    }
  }
`;

export const LanguageContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.bg?? '#f5f6f6'};
  border-radius: 4px;
  padding: 5px;
  gap: 5px;
  position: relative;
  font-weight: 700;
  &.login{
    padding: 0;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    border-radius: 8px;
  }
`;
export const LanguageOptionContainer = styled.div`
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 100;
  min-width: 90px;
  &.login{
    width: 100%;
    top: 50px;
    padding: 5px 0 0 0;
  }
`;
export const LanguageOption = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.bg?? '#ffffff'};
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 4px;
  padding: 10px 0;
  gap: 5px;
  max-height: 150px;
  overflow-y: auto;

`;
export const LanguageOptionValue = styled.div`
  padding: 5px 15px;
  cursor: pointer;
  color: #616161;
  display: flex;
  align-items: center;
  gap: 10px;
  &:hover {
    background-color: #f5f6f6;
  }
  &.active{
    color: #000000;
  }
`;
